'use strict';

import Alerts from 'lib/alerts';
import template from 'commons/templates/PersonalSettings.ejs';
import FormView from 'commons/views/Form';
import PasswordRuleTableView from 'commons/views/PasswordRuleTable';
import validate from 'validate.js';
import loader from 'helpers/loader';

module.exports = FormView.extend({

    subViews: null,
    passwordRuleTableView: null,

    events: function() {
        return Object.assign({}, FormView.prototype.events(), {
            'keyup input.js-ext-pwd': 'hidePasswordError',
            'click .js-pwd-toggle':   'togglePasswordVisibility',
            'keyup input[name="newPassword"]': 'toggleRuleDisplay'
        });
    },

    initialize: function(options) {
        this.events = Object.assign({},
            FormView.prototype.events || {},
            this.events
        );

        this.options = Object.assign({
            subViews: [],
            template: template,
            templateExtra: {}
        }, options || {});

        this.subViews = this.options.subViews || [];

        this.passwordRuleTableView = new PasswordRuleTableView();

        return FormView.prototype.initialize.apply(this, [this.options]);
    },

    toggleRuleDisplay: function(ev) {
        return this.passwordRuleTableView &&
            this.passwordRuleTableView.toggleRuleDisplay &&
            this.passwordRuleTableView.toggleRuleDisplay(ev);
    },

    validatePasswords: function() {
        const $current = this.$('input[name = currentPassword]');
        const $new     = this.$('input[name = newPassword]');
        const passwordConfirm = this.$('input[name = passwordConfirm]').val();
        const errs     = validate({
            currentPassword: $current.val(),
            newPassword:     $new.val(),
            passwordConfirm
        }, {
            currentPassword: {presence: '^Current password can\'t be blank'},
            newPassword:     {
                presence: true,
                length: {
                    minimum: 8,
                    message: '^Minimum password length is 8'
                },
                equality: {
                    attribute: 'currentPassword',
                    message: 'Cannot be the same password',
                    comparator: (a, b) => a !== b
                }
            },
            passwordConfirm: {
                presence: true,
                equality: {
                    attribute: 'newPassword',
                    message: `New password doesn't match`
                }
            }
        });

        return _.isEmpty(errs) ? false : {errors: errs};
    },

    render: function() {
        FormView.prototype.render.apply(this, arguments);

        this.$('input[name=newPassword]').pwstrength({
            ui: {
                showVerdicts: false,
                colorClasses: [
                    'danger',
                    'warning',
                    'warning',
                    'info',
                    'info',
                    'success'
                ]
            },
            common: {minChar: 8}
        });

        if (!app.user.isRequirePasswordChange()) {
            this.subViews.forEach(view => {
                this.$('.js-ext-container').append(view.render().$el);

                /* Redelegate events for subviews becasue their parent dom element
                 * changed. */
                view.undelegateEvents();
                view.delegateEvents();
            });
        }

        this.$('#password-rules').append(
            this.passwordRuleTableView.render().$el
        );

        return this;
    },

    togglePasswordVisibility: function(ev) {
        var $button = this.$(ev.currentTarget);
        var $input  = $button
            .closest('.input-group', this.el).find('input.js-ext-pwd');
        var visible = ($input.prop('type') === 'text');

        $input.prop('type', visible ? 'password' : 'text');
        $button.html(visible ? 'Show' : 'Hide');

        return this;
    },

    hidePasswordError: function(ev) {
        this.$(ev.currentTarget).closest('.has-error')
            .removeClass('has-error')
            .find('.error').text('');

        return this;
    },

    showPasswordErrors: function(errors) {
        if (!_.isEmpty(errors)) {
            this.invalid(null, errors);
        }
    },

    save: function(ev) {
        var $button    = this.$(ev.currentTarget);
        var stopLoader;

        ev.preventDefault();

        if ($button.closest('.js-ext', this.el).length > 0) {
            return;
        }

        stopLoader = loader.startFullScreen($button);

        this.trigger('save');

        this.savePassword()
            .then(() => stopLoader())
            .then(() => this.saved())
            .then(() => this.render())
            .catch(err => this.showPasswordErrors(err))
            .finally(() => stopLoader());
    },

    savePassword: function() {
        var currentPwd      = this.$('input[name=currentPassword]').val();
        var newPwd          = this.$('input[name=newPassword]').val();
        var validationError = this.validatePasswords();

        if (!_.isEmpty(validationError)) {
            return Promise.reject(validationError);
        }

        return this.model.changePassword(
            currentPwd, newPwd
        ).catch(() => {
            return Promise.reject({errors: {
                currentPassword: ['Invalid password. Please try again']
            }});
        });
    },

    saved: function() {
        this.trigger('saved');

        return Alerts.show('success', {
            title: 'Password set!',
            text: 'Your new password has been set.',
            callback: () => {
                app.userRouter.navigate('logout', {trigger: true});
            }
        });
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/PersonalSettings.js